var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from 'react';
import { API_CONFIG } from '../config/api';
export var useReviews = function (_a) {
    var siteId = _a.siteId, sortBy = _a.sortBy, filterBy = _a.filterBy, refreshTrigger = _a.refreshTrigger;
    var _b = useState([]), reviews = _b[0], setReviews = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    // Fetch reviews
    useEffect(function () {
        var fetchReviews = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, fetch("".concat(API_CONFIG.BASE_URL).concat(API_CONFIG.ENDPOINTS.REVIEWS, "?site_id=").concat(siteId, "&sortBy=").concat(sortBy, "&filterBy=").concat(filterBy, "&limit=20"))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Failed to fetch reviews');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        setReviews(data.reviews);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        setError(err_1 instanceof Error ? err_1 : new Error('An error occurred'));
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchReviews();
    }, [siteId, sortBy, filterBy, refreshTrigger]);
    // Add new review
    var addReview = function (reviewData) { return __awaiter(void 0, void 0, void 0, function () {
        var imageUrls, formData_1, uploadResponse, uploadData, response, newReview_1, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 6, , 7]);
                    imageUrls = void 0;
                    if (!((_a = reviewData.images) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 3];
                    formData_1 = new FormData();
                    reviewData.images.forEach(function (file) {
                        formData_1.append('images', file);
                    });
                    return [4 /*yield*/, fetch("".concat(API_CONFIG.BASE_URL).concat(API_CONFIG.ENDPOINTS.UPLOADS), {
                            method: 'POST',
                            body: formData_1
                        })];
                case 1:
                    uploadResponse = _b.sent();
                    if (!uploadResponse.ok) {
                        throw new Error('Failed to upload images');
                    }
                    return [4 /*yield*/, uploadResponse.json()];
                case 2:
                    uploadData = _b.sent();
                    imageUrls = uploadData.urls;
                    _b.label = 3;
                case 3: return [4 /*yield*/, fetch("".concat(API_CONFIG.BASE_URL).concat(API_CONFIG.ENDPOINTS.REVIEWS), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(__assign(__assign({}, reviewData), { siteId: siteId, images: imageUrls })),
                    })];
                case 4:
                    response = _b.sent();
                    if (!response.ok) {
                        throw new Error('Failed to add review');
                    }
                    return [4 /*yield*/, response.json()];
                case 5:
                    newReview_1 = _b.sent();
                    setReviews(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newReview_1], false); });
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _b.sent();
                    setError(err_2 instanceof Error ? err_2 : new Error('Failed to add review'));
                    throw err_2;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var updateReview = function (reviewId, updates) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    }); };
    var deleteReview = function (reviewId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    }); };
    return {
        reviews: reviews,
        loading: loading,
        error: error,
        addReview: addReview,
        updateReview: updateReview,
        deleteReview: deleteReview
    };
};
